import type { V2ConversationType } from '@/features/chat/types'
import { getDayLabel } from '@/utils/dates'

export type ChatDocumentType = {
  id: string
  name: string
  ext: string
  ownerId: string
  author: string
  sentAt: string
  dateLabel: string
  isImage: boolean
  signedUrl?: string
}

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'gif']

// pieces jointes d'une conversation, les plus recentes d'abord
export function getChatDocuments(
  conversation: V2ConversationType | null | undefined,
  dayLabels: { today: string; yesterday: string },
): ChatDocumentType[] {
  if (!conversation) return []
  return [...conversation.messages].reverse().flatMap((message) => {
    const author = conversation.users.find((user) => user.id === message.userId)
    return (message.files ?? []).map((file) => ({
      id: file.id,
      name: file.name,
      ext: file.ext,
      ownerId: message.userId,
      author: author ? `${author.firstName ?? ''} ${author.lastName ?? ''}`.trim() : '',
      sentAt: message.sentAt,
      dateLabel: getDayLabel(message.sentAt, dayLabels).toLocaleLowerCase(),
      isImage: IMAGE_EXTENSIONS.includes(file.ext.toLowerCase()),
      signedUrl: file.signedUrl,
    }))
  })
}
